import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '.';
import { CustomError } from 'src/lib/error';
import { getWebsiteDetailsByVersion } from 'src/services/site/sync/sync.service';
import logger from 'src/logger';
import { miniSerializeErrorOverride } from './serialize-error';
import { getSessionIdentifier } from 'src/helpers/session.helpers';

export const getLiveSiteDetailsAction = createAsyncThunk(
  'liveSiteData/get',
  async (version: number | undefined, { getState }) => {
    const {
      session,
      siteData: { version: latestVersion },
    } = getState() as RootState;
    try {
      if (!session) throw new CustomError({ errorCode: 'SessionNotFound' });
      if (!version) {
        version = latestVersion;
      }
      const resp = await getWebsiteDetailsByVersion({
        ...getSessionIdentifier(session),
        domainName: session.domainName,
        version,
      });

      return resp;
    } catch (err: any) {
      logger.reportError(err, { message: 'Error in getLiveSiteDetailsAction' });
      throw err;
    }
  },
  {
    serializeError: miniSerializeErrorOverride,
  },
);

const initialState = {};

const liveSiteDataSlice = createSlice({
  name: 'liveSiteData',
  initialState,
  reducers: {
    clearLiveSiteData: () => initialState,
    updateLiveSiteData: (_, action) => action.payload,
    setLiveDataUnpublished: state => ({ ...state, havePublishedSite: false }),
  },
  extraReducers: builder => {
    builder.addCase(getLiveSiteDetailsAction.fulfilled, (_, action) => action.payload);
  },
});

export const liveSiteDetailsSelector = (state: RootState) => state.liveSiteData;

export const { clearLiveSiteData, updateLiveSiteData, setLiveDataUnpublished } = liveSiteDataSlice.actions;

export default liveSiteDataSlice.reducer;
